import { render, staticRenderFns } from "./FormSubmit.vue?vue&type=template&id=7963d0e4&scoped=true&"
import script from "./FormSubmit.vue?vue&type=script&lang=js&"
export * from "./FormSubmit.vue?vue&type=script&lang=js&"
import style0 from "./FormSubmit.vue?vue&type=style&index=0&id=7963d0e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7963d0e4",
  null
  
)

export default component.exports